import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { SelectedFeaturesFromPortalState } from "../types";

export const selectFeatureFromPortalPartialReducer: IPartialReducer<SelectedFeaturesFromPortalState> = (
    state,
    action
) => {
    return {
        features: action.features,
    };
};
